
import { Component, Vue } from 'vue-property-decorator'
import ModalBasic from '~/components/common/modals/common/ModalBasic.vue'
import ButtonCustom from '@/components/common/buttons/ButtonCustom.vue'
import { FREEMIUM_EXIT_POPUP } from '@/plugins/feature-flags/flags'
import {
  FREEMIUM_EXIT_POPUP_REGULAR,
  FREEMIUM_EXIT_POPUP_SPECIAL
} from '@/plugins/feature-flags/variants'

@Component({
  components: {
    ModalBasic,
    ButtonCustom
  }
})
export default class ExitModal extends Vue {
  get variant() {
    return this.$featureFlags?.getVariant(FREEMIUM_EXIT_POPUP)?.name
  }

  get headingText() {
    return {
      [FREEMIUM_EXIT_POPUP_REGULAR]: 'Want to Get Started for Free?',
      [FREEMIUM_EXIT_POPUP_SPECIAL]: 'Special Offer! Just for you.'
    }[this.variant]
  }

  trackAndSubmit() {
    const event = this.$mixpanel.events.FREEMIUM_PAYWALL_ACCEPT_OFFER_CTA_CLICK
    const props = this.$mixpanel.fillProps(event)
    this.$mixpanel.track(event, props)
    this.$accessor.account.continueWithFreemium()
  }

  close() {
    this.$emit('close')
    this.$accessor.account.setState({ stateName: 'isContinueWithFreemiumFailed', data: false })
  }
}
